<script lang="ts">
	let {
		type = `text`,
		placeholder = ``,
		value = $bindable(``),
		...restProps
	}: {
		type?: `text` | `email` | `password` | `number` | `tel` | `url` | `search` | `textarea`
		placeholder?: string
		value?: string
		[key: string]: any
	} = $props()
</script>

{#if type === `textarea`}
	<textarea {placeholder} bind:value {...restProps}></textarea>
{:else}
	<input {type} {placeholder} bind:value {...restProps}>
{/if}

<style>
	input, textarea {
		width: 100%;
		background-color: #111;
		border: 1px solid #666;
		padding: 10px;
		border-radius: 5px;
		font-family: 'Protipo Wide', sans-serif;
		color: #fff;
		line-height: 18px;
		font-size: 14px;
		font-weight: 400;
	}
	input::placeholder, textarea::placeholder {
		color: #999;
	}
	textarea {
		line-height: 24px;
	}

	input:focus, textarea:focus {
		outline: 2px solid var(--chemlight);
	}

	input[disabled], textarea[disabled] {
		opacity: 0.5;
		cursor: not-allowed;
	}
</style>
